import React from 'react';
import PropTypes from 'prop-types';
import {LabelTooltip} from '../LabelTooltip';
import className from './style.module.scss';

/**
 * ControlTooltip
 *  - Component renders the tooltip and the controls buttons
 *    associated with the apparatus
 *  - If a label is passed in it will also render the label of the
 *    component.
 */
export function ControlTooltip(props) {
  const renderControls = () => {
    if (props.showControls) {
      return props.children;
    } else if (props.label) {
      return <LabelTooltip label={props.label} />;
    } else {
      return null;
    }
  };
  return (
    <div className={className.controlsTooltip} style={props.tooltipStyle}>
      {renderControls()}
    </div>
  );
}

ControlTooltip.propTypes = {
  /**
   * Booolean to set if contols tooltip should be displayed
   */
  showControls: PropTypes.bool,
  /**
   * style object to handle positition of tooltip
   */
  tooltipStyle: PropTypes.object,
  /**
   * Label for the Component
   */
  label: PropTypes.string,
};

ControlTooltip.defaultProps = {
  showControls: false,
};

export {ControlButtons} from './ControlButtons';
